import Modals from '../../../../modal';
/**
 * @param {import('utils/apiClients/types').Project} project
 * @returns {Promise<string>}
 */

var giveJobName = function giveJobName(project) {
  if (!project || !project.CustomJobName) return Promise.resolve();
  var resolved = false;
  return new Promise(function (resolve) {
    Modals.open({
      type: Modals.TYPES.PROMPT_INPUT,
      props: {
        windowProps: {
          header: 'Save Document'
        },
        formFieldType: 'Name',
        formField: {
          selectOnFocus: true,
          defaultValue: '',
          label: 'Document Name',
          placeholder: 'Name of the document'
        },
        submitLabel: 'Ok',
        onSubmit: function onSubmit(newName) {
          resolved = true;
          resolve(newName);
        },
        onClose: function onClose() {
          !resolved && resolve(null);
        }
      }
    });
  });
};

export default {
  giveJobName: giveJobName
};